import React from "react";

function TablaNivelAcademico() {
  return (
  <div className="tablaGrafica">
      <table>
      <thead>
        <tr>
          <th>Nivel Acad.</th>
          <th>Trabajadores</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>DOCTORADO</td>
          <td>127</td>
        </tr>
        <tr>
          <td>LICENCIATURA</td>
          <td>31442</td>
        </tr>
        <tr>
          <td>MAESTRIA</td>
          <td>2353</td>
        </tr>
        <tr>
          <td>NO DEFINIDO</td>
          <td>10107</td>
        </tr>
        <tr>
          <td>PROFESOR</td>
          <td>4576</td>
        </tr>
        <tr>
          <td>SIN GRADO</td>
          <td>3853</td>
        </tr>
        <tr>
          <td>TECNICO</td>
          <td>1052</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>Total</td>
          <td>53509</td>
        </tr>
      </tfoot>
    </table>
 
  </div>
   );
}

export default TablaNivelAcademico;
